(() => {
if (customElements.get('hundred-winter-snow')) return;
class HundredWinterSnow extends HTMLElement {
  connectedCallback() {
    this.startFrame = requestAnimationFrame(() => this.initialize());
  }
  initialize() {
    if (!this.isConnected) return;
    this.hero = this.closest('[data-winter-snow-host]');
    this.canvas = this.querySelector('canvas');
    this.ctx = this.canvas?.getContext('2d');
    if (!this.hero || !this.ctx) return;
    this.abort = new AbortController();
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.visible = false;
    this.frame = 0;
    this.last = 0;
    this.resize = new ResizeObserver(() => { this.size(); this.sync(); });
    this.resize.observe(this.hero);
    this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
    this.observer.observe(this.hero);
    const options = { signal: this.abort.signal };
    this.motion.addEventListener('change', () => this.sync(), options);
    document.addEventListener('visibilitychange', () => this.sync(), options);
    window.addEventListener('resize', () => this.size(), options);
    this.size();
  }
  flake(anywhere) {
    const r = .6 + Math.random() * 2.2;
    return { x: Math.random()*this.w, y: anywhere ? Math.random()*this.h : -4, r, v: .1+r*.12, o: .35+Math.random()*.5, d: .12+Math.random()*.25, ph: Math.random()*200 };
  }
  size() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.w = this.hero.offsetWidth;
    this.h = this.hero.offsetHeight;
    this.canvas.width = Math.round(this.w*dpr);
    this.canvas.height = Math.round(this.h*dpr);
    this.ctx.setTransform(dpr,0,0,dpr,0,0);
    const count = this.w < 750 ? Number(this.dataset.mobile || 40) : Number(this.dataset.desktop || 90);
    this.flakes = Array.from({ length: count }, () => this.flake(true));
  }
  sync() {
    cancelAnimationFrame(this.frame);
    this.frame = 0;
    this.last = 0;
    if (this.visible && !document.hidden && !this.motion.matches && this.isConnected) this.frame = requestAnimationFrame(t => this.draw(t));
    else this.ctx.clearRect(0,0,this.w,this.h);
  }
  draw(time) {
    const delta = this.last ? Math.min((time-this.last)/16.667,2) : 1;
    this.last = time;
    this.ctx.clearRect(0,0,this.w,this.h);
    for (let i=0;i<this.flakes.length;i++) {
      let p=this.flakes[i];
      p.y+=p.v*delta;
      p.x+=Math.sin((p.y+p.ph)/40)*p.d*delta;
      if(p.y>this.h+4) p=this.flakes[i]=this.flake(false);
      this.ctx.beginPath();
      this.ctx.fillStyle=`rgba(255,255,255,${p.o})`;
      this.ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
      this.ctx.fill();
    }
    this.frame=requestAnimationFrame(t => this.draw(t));
  }
  disconnectedCallback() {
    cancelAnimationFrame(this.startFrame);
    cancelAnimationFrame(this.frame);
    this.resize?.disconnect();
    this.observer?.disconnect();
    this.abort?.abort();
  }
}
if (!customElements.get('hundred-winter-snow')) customElements.define('hundred-winter-snow',HundredWinterSnow);
})();
